import { useEffect, useRef } from 'react';
import { animate, inView } from 'motion';
import { useTranslation } from 'next-i18next';
import { TrophyFillIcon } from '@zep/icons';
import { cn } from '@zep/utils';
import { AwardsTicker } from './AwardsTicker';
const USER_COUNT = 30000000;
const TICKER_DUPLICATE_COUNT = 4;
const awards = [{
  id: 1,
  icon: TrophyFillIcon,
  title: 'home:landing.numbers.edutech'
}, {
  id: 2,
  icon: TrophyFillIcon,
  title: 'home:landing.numbers.aesKorea'
}, {
  id: 3,
  icon: TrophyFillIcon,
  title: 'home:landing.numbers.vrInnovation'
}, {
  id: 4,
  icon: TrophyFillIcon,
  title: 'home:landing.numbers.aiStartup'
}] as const;
export const LandingNumbers = () => {
  const {
    t
  } = useTranslation(['home']);
  const counterRef = useRef<HTMLSpanElement>(null);
  const duplicatedAwards = Array(TICKER_DUPLICATE_COUNT).fill(awards).flat();
  useEffect(() => {
    const counter = counterRef.current;
    if (!counter) return;
    const cleanup = inView(counter, () => {
      animate(progress => {
        counter.textContent = Math.floor(progress * USER_COUNT).toLocaleString();
      }, {
        delay: 0.2,
        duration: 2,
        easing: 'ease-out'
      });
    }, {
      amount: 0.3
    });
    return cleanup;
  }, []);
  return <section className={cn('w-full', 'py-quiz-2xl tablet:py-quiz-4xl px-quiz-md tablet:px-quiz-2xl', 'flex flex-col items-center justify-center')} data-sentry-component="LandingNumbers" data-sentry-source-file="LandingNumbers.tsx">
      <div className="w-full max-w-screen-xl py-quiz-lg text-center">
        <div className="mb-quiz-sm flex justify-center">
          <div className={cn('inline-flex items-center justify-center', 'px-quiz-md py-quiz-2xs tablet:px-quiz-lg tablet:py-quiz-xs', 'rounded-quiz-xl', 'bg-gradient-to-r from-quiz-violet-400 to-quiz-blue-400')}>
            <h3 className="text-quiz-body-sm-bold text-quiz-inverse tablet:text-quiz-heading-lg-extrabold">
              {t('home:landing.numbers.totalUsers')}
            </h3>
          </div>
        </div>

        <div className="mb-quiz-2xl text-[34px] font-[800] leading-none text-quiz-gray-900 tablet:text-[80px]">
          <span ref={counterRef}>
            0
            <span aria-hidden hidden>
              {USER_COUNT.toLocaleString()}
            </span>
          </span>
          {' +'}
        </div>

        <div className="w-full">
          <AwardsTicker awards={duplicatedAwards} data-sentry-element="AwardsTicker" data-sentry-source-file="LandingNumbers.tsx" />
        </div>
      </div>
    </section>;
};